$(document).ready(function(){

	// Pagination Container
	$(".tx-indexedsearch-browsebox").addClass("pagination").addClass("list-unstyled").css("visibility","visible").show();

	// Current
	$(".tx-indexedsearch-browselist-currentPage").addClass("current");

	var currentLink = $(".tx-indexedsearch-browselist-currentPage strong").html();
	$(".tx-indexedsearch-browselist-currentPage").html( currentLink );


	// Prev / Next
	$(".tx-indexedsearch-browsebox li").each(function(){

		if ( $("a", this).text() == ">" ) {
			$("a", this).attr("aria-label","Next");
			$("a", this).html('<span aria-hidden="true">»</span>');
		}

		if ( $("a", this).text() == "<" ) {
			$("a", this).attr("aria-label","Previous");
			$("a", this).html('<span aria-hidden="true">«</span>');
		}

	});


	// Teaser Link
	var teaserLinkUrl;
	var teaserLinkText;
	$(".list--indexedsearch .list-item").each(function(){

		teaserLinkText = $("h4 a", this).text();
		teaserLinkUrl = $("h4 a", this).attr("href");

		$("h4", this).html( teaserLinkText );

		$( ".text", this ).wrap( '<a href="' + teaserLinkUrl + '"></a>' );

	})

});
